import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    getLiquidacionesListaSellers,
    getTiposConceptos,
    postNovedad
} from '../../../../api/axios';
import { fetchLiquidacionesListaSellers } from '../../../../actions/sellersActions';
import { fetchListaConceptos } from '../../../../actions/tiposActions';
import { DropDownArrow, EstiloCombos } from "../../../../template/CustomStyle";
import GoBackArrow from '../../../General/GoBackArrow';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { validateNumber } from "../../../../utilities/formatoNumeros";
import { filtroSesenta } from "../../../../utilities/fechasFiltro";

/** Select compacto; menú en portal para no quedar recortado por overflow del card/barra */
const selectToolbarStyle = {
    ...EstiloCombos,
    control: (base, state) => {
        const b = EstiloCombos.control(base, state);
        return {
            ...b,
            minHeight: 36,
            fontSize: "0.875rem",
        };
    },
    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
    indicatorsContainer: (base) => ({ ...base, height: 34 }),
    menuPortal: (base) => ({ ...base, zIndex: 10050 }),
    menu: (base) => ({ ...base, zIndex: 10050 }),
};

const fechaFiltro = filtroSesenta();

/** Detecta si el concepto de la API corresponde a penalidad (texto en concepto / detalle). */
const conceptoEsPenalidad = (tipo) => {
    if (!tipo || typeof tipo !== "object") return false;
    const texto = `${tipo.idConcepto ?? tipo.IdConcepto ?? ""} ${tipo.detalleConcepto ?? tipo.DetalleConcepto ?? ""} ${tipo.descripcionSubTipoNovedad ?? tipo.DescripcionSubTipoNovedad ?? ""}`.toLowerCase();
    return texto.includes("penalidad");
};

const validatePorcentajeInput = (text) => {
    if (text === "") return true;
    return /^[0-9]+([.,][0-9]{0,2})?$/.test(String(text).trim());
};

// Wrapper para usar hooks en class component
function NovedadNewWrapper(props) {
    const navigate = useNavigate();
    return <NovedadNew {...props} navigate={navigate} />;
}


class NovedadNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listSellers: [],
            comboSeller: { label: "", value: "" },
            comboConceptos: { label: "", value: "", esPenalidad: false },
            fecha: fechaFiltro.hasta,
            fechaDesdeSesenta: fechaFiltro.desde,
            comision: 0,
            importe: "",
            porcentajePenalidad: "",
            observaciones: "",
            ordenReferencia: "",
            listaTipoConcepto: [],
            listaTipoConceptoRaw: []
        };
        this.importeInputRef = React.createRef();
    }

    componentDidMount() {
        this.props.fetchLiquidacionesListaSellers();
        this.props.fetchListaConceptos();

        getLiquidacionesListaSellers().then(res => {
            const array = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            });
            this.setState({ listSellers: array });
        });

        getTiposConceptos().then(res => {
            const raw = res.listaConceptoNovedades || [];
            const listaAccion = raw.map((tipo) => ({
                label: tipo.idConcepto,
                value: tipo.idTipoNovedad,
                esPenalidad: conceptoEsPenalidad(tipo)
            }));
            this.setState({ listaTipoConcepto: listaAccion, listaTipoConceptoRaw: raw });
        });

        if (this.importeInputRef.current) {
            this.importeInputRef.current.focus();
        }
    }

    handleChange = async (e) => {
        const { name, value } = e.target;
        if (name === "importe" && !validateNumber(value)) return;
        if (name === "porcentajePenalidad" && !validatePorcentajeInput(value)) return;
        this.setState({ [name]: value });
    }

    handleChangeSeller = (option) => {
        this.setState({ comboSeller: option || { label: "", value: "" } });
    };

    handleChangeConcepto = (option) => {
        const patch = {
            comboConceptos: option || { label: "", value: "", esPenalidad: false }
        };
        if (!option?.esPenalidad) {
            patch.porcentajePenalidad = "";
        }
        this.setState(patch);
    };

    onSubmit = async (event) => {
        event.preventDefault();
        const {
            fecha,
            importe,
            comboSeller,
            comboConceptos,
            ordenReferencia,
            observaciones,
            porcentajePenalidad,
        } = this.state;


        if (!fecha) {
            toast.warn("Debe agregar una fecha");
            return;
        }

        if (!comboSeller.value) {
            toast.warn("Debe seleccionar un seller");
            return;
        }

        if (!comboConceptos.value) {
            toast.warn("Debe seleccionar un concepto");
            return;
        }

        if (!importe) {
            toast.warn("Debe agregar un importe");
            return;
        }

        if (comboConceptos.esPenalidad) {
            const pct = String(porcentajePenalidad ?? "").trim().replace(",", ".");
            if (pct === "" || Number.isNaN(parseFloat(pct))) {
                toast.warn("Debe ingresar el porcentaje de penalidad");
                return;
            }
            const num = parseFloat(pct);
            if (num < 0 || num > 100) {
                toast.warn("El porcentaje de penalidad debe estar entre 0 y 100");
                return;
            }
        }

        const request = {
            fecha: fecha,
            idSeller: parseInt(comboSeller.value, 10),
            idTipoNovedad: parseInt(comboConceptos.value, 10),
            importe: parseFloat(importe),
            ordenDeReferencia: ordenReferencia ? parseInt(ordenReferencia, 10) : 0,
            observaciones: observaciones,
        };

        if (comboConceptos.esPenalidad) {
            const pct = String(porcentajePenalidad).trim().replace(",", ".");
            request.porcentaje = parseFloat(pct);
        }

        const post = postNovedad(request);

        post.then(res => {
            toast.success("La novedad fue creada con éxito.");
            this.clearInputs();
            return;
        }).catch(err => {
            toast.error("No pudimos crear la liquidación");
        });
    }

    mapSellers = () => {
        getLiquidacionesListaSellers().then(res => {
            const array = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            });
            this.setState({ listSellers: array });
        });
    }

    mapConceptos = () => {
        getTiposConceptos().then(res => {
            const raw = res.listaConceptoNovedades || [];
            const listaAccion = raw.map((tipo) => ({
                label: tipo.idConcepto,
                value: tipo.idTipoNovedad,
                esPenalidad: conceptoEsPenalidad(tipo)
            }));
            this.setState({ listaTipoConcepto: listaAccion, listaTipoConceptoRaw: raw });
        });
    }

    clearInputs = () => {
        this.setState({
            comboSeller: { label: "", value: "" },
            comboConceptos: { label: "", value: "", esPenalidad: false },
            importe: "",
            porcentajePenalidad: "",
            ordenReferencia: "",
            observaciones: "",
        });
    }

    goToNovedades = () => {
        this.props.navigate("/Novedades");
    }


    render() {
        const muestraPenalidad = this.state.comboConceptos?.esPenalidad;

        return (
            <form className="container-fluid px-3 px-md-4 pb-4" onSubmit={this.onSubmit}>
                <div
                    className="row align-items-center mb-3 py-3 px-2 rounded"
                    style={{
                        background: "linear-gradient(to right, #f8f9fa 0%, #fff 100%)",
                        borderLeft: "4px solid var(--rojo-megatone, #c00)",
                    }}
                >
                    <div className="col-auto pe-2">
                        <GoBackArrow />
                    </div>
                    <div className="col">
                        <h4 className="mb-0 text-themecolor color-rojo-megatone fw-bold">Crear Novedad</h4>
                        <p className="mb-0 small text-muted">Registre la novedad en una liquidación.</p>
                    </div>
                </div>

                <div className="card shadow-sm border-0">
                    <div className="card-header bg-light py-2 border-bottom d-flex align-items-center justify-content-between flex-wrap gap-2">
                        <span className="fw-semibold text-dark small mb-0">Datos principales</span>
                        <span className="text-muted small mb-0 d-none d-md-inline">Los campos obligatorios se validan al guardar</span>
                    </div>
                    <div className="card-body p-3 overflow-visible">
                        <div className="novedad-toolbar-scroll overflow-x-auto overflow-y-visible pb-1" style={{ WebkitOverflowScrolling: "touch" }}>
                        <div className="d-flex flex-nowrap align-items-end gap-2 gap-md-3" style={{ minWidth: "min-content" }}>
                            <div className="flex-shrink-0" style={{ width: "152px" }}>
                                <label htmlFor="novedad-fecha" className="form-label small text-muted mb-1">Fecha</label>
                                <input
                                    id="novedad-fecha"
                                    type="date"
                                    name="fecha"
                                    className="form-control form-control-sm"
                                    min={this.state.fechaDesdeSesenta}
                                    value={this.state.fecha}
                                    onChange={this.handleChange}
                                />
                            </div>

                            <div className="flex-grow-1" style={{ minWidth: "140px", maxWidth: "240px" }}>
                                <label className="form-label small text-muted mb-1">Seller</label>
                                <Select
                                    name="comboSeller"
                                    inputId="novedad-seller"
                                    value={this.state.comboSeller}
                                    options={this.state.listSellers}
                                    onChange={this.handleChangeSeller}
                                    onMenuOpen={this.mapSellers}
                                    placeholder="Seleccionar…"
                                    styles={selectToolbarStyle}
                                    menuPosition="fixed"
                                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                    components={{ DropdownIndicator: () => DropDownArrow }}
                                />
                            </div>

                            <div className="flex-grow-1" style={{ minWidth: "140px", maxWidth: "260px" }}>
                                <label className="form-label small text-muted mb-1">Concepto</label>
                                <Select
                                    name="comboConceptos"
                                    inputId="novedad-concepto"
                                    value={this.state.comboConceptos}
                                    options={this.state.listaTipoConcepto}
                                    onChange={this.handleChangeConcepto}
                                    onMenuOpen={this.mapConceptos}
                                    placeholder="Seleccionar…"
                                    styles={selectToolbarStyle}
                                    menuPosition="fixed"
                                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                    components={{ DropdownIndicator: () => DropDownArrow }}
                                />
                            </div>

                            {muestraPenalidad ? (
                                <div className="flex-shrink-0" style={{ width: "96px" }}>
                                    <label htmlFor="novedad-pct" className="form-label small text-muted mb-1">% Penal.</label>
                                    <input
                                        id="novedad-pct"
                                        type="text"
                                        name="porcentajePenalidad"
                                        className="form-control form-control-sm text-center"
                                        placeholder="0"
                                        onChange={this.handleChange}
                                        value={this.state.porcentajePenalidad}
                                        maxLength="6"
                                        inputMode="decimal"
                                        autoComplete="off"
                                    />
                                </div>
                            ) : null}

                            <div className="flex-shrink-0" style={{ width: "120px" }}>
                                <label htmlFor="novedad-importe" className="form-label small text-muted mb-1">Importe</label>
                                <input
                                    id="novedad-importe"
                                    type="text"
                                    name="importe"
                                    className="form-control form-control-sm"
                                    onChange={this.handleChange}
                                    value={this.state.importe}
                                    maxLength="10"
                                    ref={this.importeInputRef}
                                />
                            </div>

                            <div className="flex-shrink-0" style={{ width: "128px" }}>
                                <label htmlFor="novedad-orden" className="form-label small text-muted mb-1">Ord. ref.</label>
                                <input
                                    id="novedad-orden"
                                    type="text"
                                    name="ordenReferencia"
                                    className="form-control form-control-sm"
                                    onChange={this.handleChange}
                                    maxLength="10"
                                    value={this.state.ordenReferencia}
                                />
                            </div>

                            <div className="d-flex flex-shrink-0 gap-2 ms-auto pt-1">
                                <button
                                    type="submit"
                                    className="btn btn-sm background-rojo-megatone text-white shadow-sm text-nowrap"
                                >
                                    <i className="fa fa-check me-1" aria-hidden="true" />
                                    Crear
                                </button>
                                <button
                                    type="button"
                                    onClick={this.goToNovedades}
                                    className="btn btn-sm btn-outline-secondary text-nowrap"
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                        </div>

                        <div className="mt-3 pt-3 border-top border-light">
                            <label htmlFor="novedad-obs" className="form-label small text-muted mb-1">Observaciones</label>
                            <textarea
                                id="novedad-obs"
                                rows={2}
                                name="observaciones"
                                className="form-control form-control-sm"
                                onChange={this.handleChange}
                                value={this.state.observaciones}
                                placeholder="Opcional"
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    publicacion: state.publicaciones.publicacion,
    tiposConceptos: state.tipos.tipoLiquidacionConcepto,
    listSellers: state.sellers.lista_sellers_liquidaciones
});

export default connect(mapStateToProps, {
    fetchListaConceptos,
    fetchLiquidacionesListaSellers
})(NovedadNewWrapper);
